import React from 'react';
import initializeComponent from '../../Shared/react-initialize';
import { trackEvent } from '../../Shared/utils.js';
import { withTheme } from './themes';
import {
   color,
   breakpoint,
   borderRadius,
   space,
   fontSize,
   fontWeight,
   lineHeight,
} from '@core-ds/primitives';
import styled from 'styled-components';
import { Button, BreakpointsContext, withBreakpointsContext } from 'core-components';

import fall2020Theme from './major_campaign_banner_css_2020.js';

const CampaignStyleContainer = styled.div`
   ${fall2020Theme}
   ${props => props.css}
`;

const CampaignContainer = styled.div`
   /* Ugly-ass IE11 hack, without a height, vertical centering doesn't work */
   height: 400px;
`;

const TextContainer = styled.div``;

const CampaignBannerTitle = styled.div``;

const CampaignBannerSubtitle = styled.div``;

const CampaignBannerButton = styled(Button)`
   font-weight: 900;
   color: ${props => props.theme.fontColor};
   background: ${props => props.theme.buttonColor};

   &:hover,
   &:focus {
      background-color: ${props => props.theme.buttonHoverColor};
   }

   &:visited {
      color: ${props => props.theme.fontColor};
   }
`;

const NewText = styled.div`
   font-size: ${fontSize[1]};
`;

const Wrapper = styled.div`
   background-image: url(${props => props.imageUrl});
   background-position-x: ${props => props.cssBackgroundPositionX};
   background-position-y: 50%;
`;

const CampaignGraphic = props => {
   const {
      cssBackgroundPositionX,
      imageUrl,
      bannerTitle,
      bannerSubTitle,
      buttonText,
      bannerLink,
   } = props;
   const onClick = () => trackEvent('Major Campaign Banner', 'Click', bannerTitle);

   return (
      <Wrapper
         className="campaign-image-container"
         imageUrl={imageUrl}
         cssBackgroundPositionX={cssBackgroundPositionX}
      >
         <TextContainer className="campaign-text">
            <NewText className="campaign-new">NEW</NewText>
            <CampaignBannerTitle className="campaign-title">{bannerTitle}</CampaignBannerTitle>
            <CampaignBannerSubtitle className="campaign-subtitle">
               {bannerSubTitle}
            </CampaignBannerSubtitle>
            <CampaignBannerButton
               href={bannerLink}
               onClick={onClick}
               size="large"
               buttonType="primary"
               className="campaign-button"
            >
               {buttonText}
            </CampaignBannerButton>
         </TextContainer>
      </Wrapper>
   );
};

const getGraphicProps = props => {
   const breakpoints = React.useContext(BreakpointsContext);
   const { buttonText, bannerLink, desktop, mobile } = props;
   const graphicProps = breakpoints.isDesktop() ? desktop : mobile;

   const { bannerGraphic } = graphicProps;
   const imageUrl = bannerGraphic;

   return {
      ...graphicProps,
      imageUrl,
      bannerLink,
      buttonText,
   };
};

const MajorCampaignBanner = props => {
   const graphicProps = getGraphicProps(props);

   return (
      <CampaignStyleContainer css={props.css}>
         <CampaignContainer className="campaign-container">
            <CampaignGraphic {...graphicProps} />
         </CampaignContainer>
      </CampaignStyleContainer>
   );
};

const ThemedMajorCampaignBanner = withBreakpointsContext(withTheme(MajorCampaignBanner));

initializeComponent('MajorCampaignBanner', ThemedMajorCampaignBanner);
